import { apiGET, apiPOST, apiPUT, apiDELETE } from './api';

export const getSiteGroups = siteId => apiGET(`/sites/${siteId}/groups`);

export const getSiteGroup = (siteId, groupId) => apiGET(`/sites/${siteId}/groups/${groupId}`);

export const createSiteGroup = (siteId, data) => apiPOST(`/sites/${siteId}/groups`, data);

export const updateSiteGroup = (siteId, groupId, data) => apiPUT(`/sites/${siteId}/groups/${groupId}`, data);

export const deleteSiteGroup = (siteId, groupId) => apiDELETE(`/sites/${siteId}/groups/${groupId}`);

export const addGroupUsers = (siteId, groupId, userIds) =>
  apiPOST(`/sites/${siteId}/groups/${groupId}/users`, { user_ids: userIds });

export const removeGroupUser = (siteId, groupId, userId) =>
  apiDELETE(`/sites/${siteId}/groups/${groupId}/users/${userId}`);
